<div class="panel-body panel-body-bottom">
    <!-- PRE-J abstract list -->
    <ng-container *ngFor="let preJAabstract of civilCase.getPreJAAbstractList(); let ja = index; let last = last;">
    <div class="col-md-12 panel panel-default panel-margin-top panel-margin-bottom"  [id]="'J-' + preJAabstract.getPreJAAbstractNumber()">
      <div class="panel-title summary-label">
        <span class="field-code">V189a V230a json='abstracts.abstractNumber'</span> 
        Judgment {{preJAabstract.getPreJAAbstractNumber()}}:     
      </div>
      <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
        <div class="panel panel-default">
          <div class="row row-eq-height">
            <table width="100%">
            <tr width="100%">
              <td width="10%" align="center" valign="middle">
                <span><i class="fa fa-exclamation-circle fa-3x exclamation"></i></span>
              </td>
              <td align="left"><span class="field-code">V510</span>
                The electronic abstract is incomplete for this judgment.
                  <span class="field-code">V058a</span>{{preJAabstract.getPreJAPartialAbstract(civilCase)}}
              </td>
            </tr>
            </table>
          </div>
        </div>
        <div class="row panel-margin-bottom panel-margin-top">      
          <div class="col-md-6 panel panel-default">
            <div id="V231a" class="panel-title">
             <span class="field-code">V231a json='clockDate' </span> 
             Clocked In On
            </div>
            <div class="panel-body panel-body-bottom" id="civil-caseDetails-judgmentAbstracts-recordedOn">
              {{preJAabstract.getPreJAClockedInOnDate() | date: 'MM/dd/yyyy'}}
            </div>
          </div>
          <div class="col-md-6 panel panel-default" *ngIf="preJAabstract.getPreJAAbstractStatus() !== ''">
            <div id="V178a" class="panel-title">
              <span class="field-code">V178a json='abstractStatus.code#', 'abstracts.cancelDate', 'abstracts.vacatedDate', 'abstractCancelReasonCode.descriptionn' </span>
              Abstract Status
            </div>
            <div class="panel-body panel-body-bottom" id="civil-caseDetails-judgmentAbstracts-cancelDate">
              {{preJAabstract.getPreJAAbstractStatus()}}
              {{preJAabstract.getPreJAAbstractStatusDate() | date:'MM/dd/yyyy'}}{{preJAabstract.getPreJAAbstractCancelReasonCodeDescription()}}
            </div>
          </div>
        </div>
      
        <div class="row panel-margin-bottom panel-margin-top">
          <div class="col-md-12 panel panel-default" [id]="'J-parties-' + preJAabstract.getPreJAAbstractNumber()">
            <div id="{{'X090-' + ja}}" class="panel-title summary-label">
                Parties Affected by this Judgment and Payoff Amounts 
            </div>
            <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
              <div class="panel panel-default">
                  <div class="row row-eq-height">
                  <table width="100%">
                  <tr width="100%">
                    <td width="10%" align="center" valign="middle">
                      <span><i class="fa fa-exclamation-circle fa-3x exclamation"></i></span>
                    </td>
                    <td align="left"><span class="field-code">V496</span>
                      <ul>
                        <li id="{{'V469-1-' + ja}}">
                          Payoff amounts were calculated on  
                          {{preJAabstract.getPayoffCalculatedDate() | date:'MM/dd/yyyy'}}
                          based on the information retrieved from the system of record on {{civilCase.searchRecordLastUpdateDate | date:'MM/dd/yyyy'}} at {{civilCase.searchRecordLastUpdateDate | date:'hh:mm a'}}. 
                          For the most accurate payoff amount, please see the clerk.
                        </li>
                        <li>Judgment details other than money awards exist. The calculated payoff may not be accurate.
                        </li>
                        <li id="{{'V496-4-' + ja}}">
                          Any payoff amount shown here is not binding on the creditor.
                        </li>
                      </ul>
                    </td>
                  </tr>
                 </table>
                </div>
            </div>
          </div>
          <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
            <div class="panel panel-default">
              <div class="table-responsive">
                <table class="table table-condensed table-striped">
                  <thead>
                    <tr>
                      <th id="{{'V068g-' + ja}}">
                        <span class="field-code">V068g V052f V053f json='casePartyRef'</span> 
                        Debtor
                      </th>
                      <th id="{{'V034-' + ja}}">
                        <span class="field-code">V034 json='abstractPartyStatus#', 'cancelDate' </span> 
                        Status of Judgment with Respect to Party
                      </th>
                      <th id="{{'V286b-' + ja}}">
                        <span class="field-code">V286b json='?' </span> 
                        Payoff Amount 
                        <br>
                        <span style="color:red;">
                          Calculated on {{preJAabstract.getPayoffCalculatedDate() | date:'MM/dd/yyyy'}} 
                          <span popover={{civilCase.getPayoffHoverDisclaimer()}}>
                            <span class="glyphicon glyphicon-info-sign">
                            </span>
                          </span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template ngFor let-ap="index" let-abstractParty [ngForOf]="preJAabstract.getAbstractPartiesList(civilCase, 'A')">                                 
                      <tr>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedParty'}}">
                          {{preJAabstract.getAffectedParty(civilCase, abstractParty)}}
                          <div *ngIf="preJAabstract.getAbstractPartiesList(civilCase, 'A').length > 1">
                            <span class="glyphicon glyphicon-exclamation-sign" style="color:rgb(174, 147, 108);font-size:15px;"></span> 
                            Parties are jointly and severally liable.
                          </div>
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedPartyStatus'}}">
                         {{preJAabstract.getAfffectedPartyStatus(civilCase, abstractParty)}} 
                         {{preJAabstract.getAfffectedPartyCancelDateIfPresent(civilCase, abstractParty) | date:'MM/dd/yyyy'}}
                        </td>
                        <td>
                          <div>
                            <span style="font-weight:bold;;color:red;">
                              {{preJAabstract.getPayoffCalculatorBalanceTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                            </span>
                            <div *ngIf="preJAabstract.getIsPreJAPartiallyAbstracted() === true">
                              INCOMPLETE 
                              <span popover="Payoff amount cannot be calculated. See clerk for payoff amount.">
                                <span class="glyphicon glyphicon-info-sign"></span>
                              </span>
                            </div>
                          </div> 
                          <div *ngIf="preJAabstract.getPreJAShowPayoffInterestMessage(abstractParty) === true">                           
                            <span class="field-code">V390a</span>{{preJAabstract.getPreJAPayoffCalculatorDailyInterestMessage(abstractParty)}}
                            <br>
                          </div>
                          <a id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-showCalculations'}}"
                            title="Click to show payoff calculations" (click)="preJAabstract.showPreJAPayoffCalculation(ap);" *ngIf="preJAabstract.getPreJAPayoffCalculationsShowFlag(ap) === false">
                          <span class="glyphicon glyphicon-plus glyphicon-percent-80"></span><span>Show Calculations </span>
                          </a>
                          <a id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-hideCalculations'}}"
                          title="Click to hide calculations" (click)="preJAabstract.hidePreJAPayoffCalculation(ap);" *ngIf="preJAabstract.getPreJAPayoffCalculationsShowFlag(ap) === true" >
                          <span class="glyphicon glyphicon-minus"></span><span>Hide Calculations</span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="border-top: 0px solid #ddd;">
                        </td>
                        <td colspan=3>
                          <div class="table-responsive" *ngIf="preJAabstract.getPreJAPayoffCalculationsShowFlag(ap) === true">
                            <table class="table table-condensed table-striped">
                              <thead>
                                <tr>
                                    <th>
                                      </th>
                                  <th id="{{'V250-' + ja}}" style="text-align:right;">
                                    Principal
                                  </th>
                                  <th id="{{'V390-' + ja}}" style="text-align:right;">
                                    Interest
                                  </th>
                                  <th id="{{'V245-' + ja}}" style="text-align:right;">
                                    Total
                                  </th>
                                </tr>  
                              </thead>                          
                              <tbody>
                                <tr>                                                
                                  <th id="{{'payOffCalculation-' + ja + '-orderedLabel'}}">
                                    Ordered
                                  </th>                                
                                  <td id="{{'V497-' + ja + '-payoffCalculatorAssessedMoneyAward'}}" style="text-align:right;">
                                      <span class="field-code">V497</span>
                                      {{preJAabstract.getPayoffCalculatorOrderedMoneyAward(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V500-' + ja + '-payoffCalculatorAssessedInterest'}}" style="text-align:right;">
                                      <span class="field-code">V500</span>
                                      {{preJAabstract.getPayoffCalculatorOrderedInterest(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V506-' + ja + '-payoffCalculatorAssessedTotal'}}" style="text-align:right;">
                                      <span class="field-code">V506</span>
                                      {{preJAabstract.getPayoffCalculatorOrderedTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                </tr>                              
                                <tr>                            
                                  <th id="{{'Paid-' + ja}}">
                                    Paid
                                  </th>
                                  <td id="{{'V498-' + ja + '-payoffCalculatorPaidMoneyAward'}}" style="text-align:right;">
                                      <span class="field-code">V498</span>
                                      {{preJAabstract.getPayoffCalculatorPaidMoneyAward(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V501-' + ja + '-payoffCalculatorInterest'}}" style="text-align:right;">
                                      <span class="field-code">V501</span>
                                      {{preJAabstract.getPayoffCalculatorPaidInterest(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V507-' + ja + '-payoffCalculatorPaidTotal'}}" style="text-align:right;">
                                      <span class="field-code">V507</span>
                                      {{preJAabstract.getPayoffCalculatorPaidTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                </tr>
                                <tr style="border-top-width:2px;">                             
                                  <th id="{{'Balance' + ja}}">
                                    Balance
                                  </th>
                                  <td id="{{'V499-' + ja + '-payoffCalculatorBalanceMoneyAward'}}" style="text-align:right;">
                                      <span class="field-code">V499</span>
                                      {{preJAabstract.getPayoffCalculatorBalanceMoneyAward(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V502-' + ja +'-payoffCalculatorBalanceInterest'}}" style="text-align:right;">
                                      <span class="field-code">V502</span>
                                      {{preJAabstract.getPayoffCalculatorBalanceInterest(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V508-' + ja +'-payoffCalculatorBalanceTotal'}}" style="text-align:right;">
                                      <span class="field-code">V508</span>
                                      {{preJAabstract.getPayoffCalculatorBalanceTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                      <div *ngIf="preJAabstract.getIsPreJAPartiallyAbstracted() === true">
                                        INCOMPLETE 
                                        <span popover="Total balance amount cannot be calculated. See clerk for amount.">
                                          <span class="glyphicon glyphicon-info-sign"></span>
                                        </span>
                                      </div>
                                    </td>
                                </tr> 
                              </tbody> 
                            </table>
                          </div>
                        </td>
                      </tr>                          
                  </ng-template>                        
                </table>
              </div>
            </div>
          </div>
          <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
              <div class="panel panel-default">
                <div class="table-responsive">
                  <table class="table table-condensed table-striped">
                    <thead>
                      <tr>
                        <th id="{{'V068g-' + ja}}">
                          <span class="field-code">V068g V052f V053f json='casePartyRef'</span> 
                          Creditor
                        </th>
                        <th id="{{'V034-' + ja}}">
                          <span class="field-code">V034 json='abstractPartyStatus#', 'cancelDate' </span>                         
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-template ngFor let-ap="index" let-abstractParty [ngForOf]="preJAabstract.getAbstractPartiesList(civilCase, 'B')">                                 
                        <tr>
                          <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedParty'}}">
                            {{preJAabstract.getAffectedParty(civilCase, abstractParty)}}
                          </td>
                          <td></td>
                        </tr>
                      </ng-template>  
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="row panel-margin-bottom panel-margin-top">
          <div class="col-md-12 panel panel-default">
            <div id="{{'X004c'}}" class="panel-title summary-label">
             Issues Covered by this Judgment
            </div>
            <div class="panel-body panel-body-bottom">
              <div class="table-responsive">
                <table class="table table-condensed table-striped">
                 <thead>
                   <tr>
                    <th id="{{'V004b-' + ja}}">
                      <span class="field-code">V004b json='pleadings.clockDate' </span> Issue Clocked In
                    </th>
                    <th id="{{'V051b-' + ja}}">
                      <span class="field-code">V051b json='pleadings.pleadingType.description' </span> Filing
                    </th>
                    <th id="{{'V005b-' + ja}}">
                      <span class="field-code">V005b json='issues.issueType.description' </span> Issue
                    </th>
                   </tr>
                 </thead>
                 <tbody>
                   <tr>
                     <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-issuesCovered-' + '-issueClockedIn'}}">
                      {{preJAabstract.getPreJAIssueClockedInDate(civilCase) | date:'MM/dd/yyyy'}}
                     </td>
                     <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-issuesCovered-' + '-pleadingKey'}}">
                      {{preJAabstract.getPreJAPleadingTypeDescription(civilCase)}}
                     </td>
                     <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-issuesCovered-' + '-issueType'}}">
                       {{preJAabstract.getPreJAIssueType(civilCase)}}
                     </td>
                   </tr>
                 </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>      <!-- issues covered by this judgment-->
  
        <div class="row panel-margin-bottom panel-margin-top">
          <div class="col-sm-12 panel panel-default">
            <div class="panel-title summary-label" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-judgmentDetails'}}">
              Judgment Details
            </div>
            <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
              <div class="row row-eq-height panel-margin-bottom panel-margin-top">
                <div class="col-sm-4 panel panel-default">
                  <div class="panel-title summary-label" id="{{'V344-' + ja}}">
                    <span class="field-code">V344</span>
                    Amount of Judgment (Principal only)
                  </div>
                  <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-preJAJudgmentAmount'}}">
                    {{preJAabstract.getPreJAJudgmentAmount(civilCase) | currency:'USD':'symbol':'1.2-2'}}
                  </div>
                </div>
                <div class="col-sm-4 panel panel-default" *ngIf="preJAabstract.getPreJAInterestRate(civilCase) !== ''">
                  <div class="panel-title summary-label" id="{{'V390.f-' + ja}}"><span class="field-code">V390.f</span>
                    Interest Rate
                  </div>
                  <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-preJAInterestRate'}}">
                    {{preJAabstract.getPreJAInterestRate(civilCase)}}%
                  </div>
                </div>
                <div class="col-sm-4 panel panel-default">
                  <div class="panel-title summary-label" id="{{'V351-' + ja}}"><span class="field-code">V351</span>
                   Total Owed
                  </div>
                  <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-preJAAmountOwed'}}">
                    {{preJAabstract.getPreJAAmountOwed() | currency:'USD':'symbol':'1.2-2'}}
                    <div *ngIf="preJAabstract.getIsPreJAPartiallyAbstracted() === true">
                      INCOMPLETE 
                      <span popover="Total owed cannot be calculated. See clerk for amount.">
                       <span class="glyphicon glyphicon-info-sign"></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row panel-margin-bottom panel-margin-top">
                <div class="col-sm-12 panel panel-default">
                  <div class="table-responsive">
                    <table class="table table-condensed table-striped ">
                      <thead>
                       <tr>
                         <th id="{{'V429-' + ja}}">
                          <span class="field-code">V429</span>Amount
                         </th>
                         <th id="{{'V231.c-' + ja}}">
                          <span class="field-code">V231.c</span>Effective Date
                         </th>
                         <th id="{{'V192-' + ja}}">
                          <span class="field-code">V192</span>Transaction Type
                         </th>
                         <th id="{{'V202-' + ja}}">
                          <span class="field-code">V202</span>Transaction Source
                         </th>
                         <th id="{{'V332-' + ja}}">
                           <span class="field-code">V332</span>Reason Code
                         </th>
                         <th id="{{'V272-' + ja}}">
                           <span class="field-code">V272</span>Reference Number
                         </th>
                       </tr>
                      </thead>
                      <tbody>
                       <tr *ngFor="let transaction of preJAabstract.getPreJAjudgmentTransactionList(civilCase, preJAabstract.getKey()); let jt = index">
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + transaction + '-amount'}}"
                          *ngIf="preJAabstract.getPreJATransactionType(transaction) !== 'INTEREST RATE'">
                          {{preJAabstract.getPreJAAmount(transaction) | currency:'USD':'symbol':'1.2-2'}}                            
                         </td>
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + transaction + '-amount'}}"
                          *ngIf="preJAabstract.getPreJATransactionType(transaction) === 'INTEREST RATE'">
                           {{preJAabstract.getPreJAAmountInterest(transaction)}}%                           
                         </td>
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + jt + '-effectiveDate'}}">
                           {{preJAabstract.getPreJAEffectiveDate(transaction) | date:'MM/dd/yyyy'}}
                         </td>
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + jt + '-transactionType'}}">
                           {{preJAabstract.getPreJATransactionType(transaction)}}
                         </td>
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + jt + '-transactionSource'}}">
                           {{preJAabstract.getPreJATransactionSource(transaction)}}
                         </td>
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + jt + '-reasonCode'}}">
                           {{preJAabstract.getPreJAReasonCode(transaction)}}
                         </td>
                         <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-transaction-' + jt + '-referenceNumber'}}">
                           {{preJAabstract.getPreJAReferenceNumber(transaction)}} 
                         </td>
                       </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    <!--judgment details  -->
      </div>      <!-- panel -body -->
    </div>        <!-- panel -row -->
    </ng-container>  <!-- ng-container for pre-J abstract list -->
  <!-- ===============================     before is prej and after is post j   ==========================================-->
    <!-- Post Abstract list -->
    <ng-container *ngFor="let abstract of civilCase.getAbstractList(abstractCode); let ja = index; let last = last;">
    <div class="col-md-12 panel panel-default panel-margin-top panel-margin-bottom" [id]="'J-' + abstract.getAbstractJudgmentNumber()">
      <div class="panel-title summary-label">
        <span class="field-code">
          V189a V230a json='abstracts.abstractNumber','abstracts.clockDateTime' 
        </span> 
        <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-abstractJudgmentTitleAndNumber'}}">     
            {{abstract.getAbstractSectionTitle(false)}} {{abstract.getAbstractJudgmentNumber()}}: 
        </span>
        <span class="field-code" id="{{'V231-' + ja}}"> V231 </span>   
        <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-abstractJudgmentDateTime'}}">   
          ({{abstract.getAbstractDateTime() | date:'MM/dd/yyyy'}} at {{abstract.getAbstractDateTime() | date:'hh:mm a'}})
        </span>
      </div>
      <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
        <div class="row panel-margin-bottom panel-margin-top">
         <div class="col-md-9 panel panel-default">
            <div id="{{'V307-' + ja}}" class="panel-title">
             <span class="field-code">V307 json='abstracts.abstractType.description' </span> 
             Source
            </div>
            <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-abstractType'}}">
              Established per {{abstract.getAbstractType()}}
            </div>
         </div>
         <div class="col-md-3 panel panel-default">
          <div id="{{'V231a-' + ja}}" class="panel-title">
            <span class="field-code">V231a json='clockDateTime' </span> 
            Clocked In On
          </div>
          <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-recordedOn'}}">
            {{abstract.getClockedInOnDate() | date: 'MM/dd/yyyy'}} {{abstract.getClockedInOnDate() | date:'hh:mm a'}} 
          </div>
         </div>
        </div>
        <div class="col-md-12 panel panel-default panel-margin-bottom" *ngIf="abstract.getAbstractStatus() !== ''">
          <div id="{{'V031-' + ja}}" class="panel-title">
            <span class="field-code">V178a json='abstractStatus.code#', 'abstracts.cancelDate', 'abstracts.vacatedDate', 'abstractCancelReasonCode.descriptionn' </span>
            Abstract Status
          </div>
          <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-cancelDate'}}">
            {{abstract.getAbstractStatus()}} {{abstract.getAbstractStatusDate() | date:'MM/dd/yyyy'}}{{abstract.getAbstractCancelReasonCodeDescription()}}
          </div>
        </div>
        <div class="row panel-margin-bottom panel-margin-top">
          <div class="col-md-12 panel panel-default" [id]="'J-parties-' + abstract.getAbstractJudgmentNumber()">
            <div id="{{'X090-' + ja}}" class="panel-title summary-label">
                Parties Affected by this Judgment and Payoff Amounts 
            </div>
            <div class="panel-body panel-body-bottom"  style="padding-left: 2em;">
              <div class="row panel-margin-bottom panel-margin-top">
                <div class="panel panel-default">
                 <div class="row row-eq-height">
                  <table width="100%">
                  <tr width="100%">
                    <td width="10%" align="center" valign="middle">
                      <span><i class="fa fa-exclamation-circle fa-3x exclamation"></i></span>
                    </td>
                    <td align="left"><span class="field-code">V496</span>
                      <ul>
                        <li id="{{'V469-1-' + ja}}">
                          Payoff amounts were calculated on  
                          {{abstract.getPayoffCalculatedDate() | date:'MM/dd/yyyy'}}
                          based on the information retrieved from the system of record on {{civilCase.searchRecordLastUpdateDate | date:'MM/dd/yyyy'}} at {{civilCase.searchRecordLastUpdateDate | date:'hh:mm a'}}. 
                          For the most accurate payoff amount, please see the clerk.
                        </li>
                        <div *ngIf="abstract.getShowPayoffAmountNotAccurateMessage() === true">
                          <li id="{{'V496-3-' + ja}}">
                            Judgment details other than money awards exist. The calculated payoff may not be accurate.
                          </li>
                        </div>
                        <li id="{{'V496-4-' + ja}}">
                          Any payoff amount shown here is not binding on the creditor.
                        </li>
                      </ul>
                    </td>
                  </tr>
                  </table>
                 </div>
                </div>
              </div>
  
              <div class="row panel-margin-bottom panel-margin-top">
               <div class="panel panel-default">
                 <div class="table-responsive">
                   <table class="table table-condensed table-striped">
                     <thead>
                       <tr>
                        <th id="{{'V068g-' + ja}}">
                          <span class="field-code">V068g V052f V053f json='casePartyRef'</span> 
                          Debtor
                        </th>
                        <th id="{{'V034-' + ja}}">
                          <span class="field-code">V034 json='abstractPartyStatus#', 'cancelDate' </span> 
                          Status of Judgment with Respect to Party
                        </th>
                        <th id="{{'V286b-' + ja}}">
                          <span class="field-code">V286b json='?' </span> 
                          Payoff Amount 
                          <br>
                          <span style="color:red;">
                            Calculated on {{abstract.getPayoffCalculatedDate() | date:'MM/dd/yyyy'}} 
                            <span popover={{civilCase.getPayoffHoverDisclaimer()}}>
                              <span class="glyphicon glyphicon-info-sign">
                               </span>
                            </span>
                          </span>
                        </th>
                       </tr>
                     </thead>
                     <tbody>
                      <ng-template ngFor let-ap="index" let-abstractParty [ngForOf]="abstract.getAbstractPartiesList(civilCase, 'D')">                                 
                      <tr>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedParty'}}">
                          {{abstract.getAffectedParty(civilCase, abstractParty)}}
                          <div *ngIf="abstract.getAbstractPartiesList(civilCase, 'D').length > 1">
                            <span class="glyphicon glyphicon-exclamation-sign" style="color:rgb(174, 147, 108);font-size:15px;"></span> 
                            Parties are jointly and severally liable.
                          </div>
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedPartyStatus'}}">
                         {{abstract.getAfffectedPartyStatus(civilCase, abstractParty)}} {{abstract.getAfffectedPartyCancelDateIfPresent(civilCase,
                          abstractParty) | date:'MM/dd/yyyy'}}
                        </td>
                        <td>
                          <div *ngIf="abstract.getShowCalculatedPayoffAmount(abstractParty) === true">
                            <span style="font-weight:bold;color:red;">
                              {{abstract.getPayoffCalculatorBalanceTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}                            
                            </span>
                          </div>
                          <div *ngIf="abstract.getShowCalculatedPayoffAmount(abstractParty) === false">
                              NOT AVAILABLE <span popover="Payoff amount cannot be calculated. See clerk for payoff amount." popoverTitle="Payoff Amount"><i class="fa fa-info-circle"></i></span>
                          </div> 
                          <div *ngIf="abstract.getShowPayoffInterestMessage(abstractParty) === true">                           
                            <span class="field-code">V390a</span>{{abstract.getPayoffCalculatorDailyInterestMessage(abstractParty)}}
                            <br>
                          </div>
                          <a id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-showCalculations'}}"
                            title="Click to show payoff calculations" (click)="abstract.showPayoffCalculation(ap);" *ngIf="abstract.getPayoffCalculationsShowFlag(ap) === false && abstract.getShowDebtorPayoffCalculation(abstractParty) === true" >
                          <span  class="glyphicon glyphicon-plus glyphicon-percent-80"></span><span>Show Calculations </span>
                          </a>
                          <a id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-hideCalculations'}}"
                          title="Click to hide calculations" (click)="abstract.hidePayoffCalculation(ap);" *ngIf="abstract.getPayoffCalculationsShowFlag(ap) === true && abstract.getShowDebtorPayoffCalculation(abstractParty) === true" >
                          <span class="glyphicon glyphicon-minus"></span><span>Hide Calculations</span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="border-top: 0px solid #ddd;">
                        </td>
                        <td colspan=3>
                          <div class="table-responsive" *ngIf="abstract.getPayoffCalculationsShowFlag(ap) === true && abstract.getShowCalculatedPayoffAmount(abstractParty) === true">
                            <table class="table table-condensed table-striped">
                              <thead>
                                <tr>
                                    <th>
                                      </th>
                                  <th id="{{'V250-' + ja}}" style="text-align:right;">
                                    Principal
                                  </th>
                                  <th id="{{'V390-' + ja}}" style="text-align:right;">
                                    Interest
                                  </th>
                                  <th id="{{'V251-' + ja}}" style="text-align:right;">
                                    Costs & Fees
                                  </th>
                                  <th id="{{'V245-' + ja}}" style="text-align:right;">
                                    Total
                                  </th>
                                </tr>  
                              </thead>                          
                              <tbody>
                                <tr>                                                
                                  <th id="{{'payOffCalculation-' + ja + '-orderedLabel'}}">
                                    Ordered
                                  </th>                                
                                  <td id="{{'V497-' + ja + '-payoffCalculatorAssessedMoneyAward'}}" style="text-align:right;">
                                      <span class="field-code">V497</span>
                                      {{abstract.getPayoffCalculatorOrderedMoneyAward(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V500-' + ja + '-payoffCalculatorAssessedInterest'}}" style="text-align:right;">
                                      <span class="field-code">V500</span>
                                      {{abstract.getPayoffCalculatorOrderedInterest(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V503-' + ja + '-payoffCalculatorAssessedCostsAndFees'}}" style="text-align:right;">
                                      <span class="field-code">V503</span>
                                      {{abstract.getPayoffCalculatorOrderedCostsAndFees(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V506-' + ja + '-payoffCalculatorAssessedTotal'}}" style="text-align:right;">
                                      <span class="field-code">V506</span>
                                      {{abstract.getPayoffCalculatorOrderedTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                </tr>                              
                                <tr>                            
                                  <th id="{{'Paid-' + ja}}">
                                    Paid
                                  </th>
                                  <td id="{{'V498-' + ja + '-payoffCalculatorPaidMoneyAward'}}" style="text-align:right;">
                                      <span class="field-code">V498</span>
                                      {{abstract.getPayoffCalculatorPaidMoneyAward(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V501-' + ja + '-payoffCalculatorInterest'}}" style="text-align:right;">
                                      <span class="field-code">V501</span>
                                      {{abstract.getPayoffCalculatorPaidInterest(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V504-' + ja + '-payoffCalculatorPaidCostsAndFees'}}" style="text-align:right;">
                                      <span class="field-code">V504</span>
                                      {{abstract.getPayoffCalculatorPaidCostsAndFees(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V507-' + ja + '-payoffCalculatorPaidTotal'}}" style="text-align:right;">
                                      <span class="field-code">V507</span>
                                      {{abstract.getPayoffCalculatorPaidTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                </tr>
                                <tr style="border-top-width:2px;">                             
                                  <th id="{{'Balance-' + ja}}">
                                    Balance
                                  </th>
                                  <td id="{{'V499-' + ja + '-payoffCalculatorBalanceMoneyAward'}}" style="text-align:right;">
                                      <span class="field-code">V499</span>
                                      {{abstract.getPayoffCalculatorBalanceMoneyAward(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V502-' + ja +'-payoffCalculatorBalanceInterest'}}" style="text-align:right;">
                                      <span class="field-code">V502</span>
                                      {{abstract.getPayoffCalculatorBalanceInterest(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V505-' + ja + '-payoffCalculatorBalanceCostsAndFees'}}" style="text-align:right;">
                                      <span class="field-code">V505</span>
                                      {{abstract.getPayoffCalculatorBalanceCostsAndFees(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                  <td id="{{'V508-' + ja +'-payoffCalculatorBalanceTotal'}}" style="text-align:right;">
                                      <span class="field-code">V508</span>
                                      {{abstract.getPayoffCalculatorBalanceTotal(abstractParty) | currency:'USD':'symbol':'1.2-2'}}
                                  </td>
                                </tr>                             
                             </tbody> 
                            </table>
                          </div>
                        </td>
                      </tr>                          
                      </ng-template>                     
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
         
              <div class="row panel-margin-bottom panel-margin-top">
               <div class="panel panel-default">
                 <div class="table-responsive">
                   <table class="table table-condensed table-striped">
                    <thead>
                     <tr>
                      <th id="{{'V068g-' + ja}}">
                        <span class="field-code">V068g V052f V053f json='casePartyRef'</span> 
                        Creditor
                      </th>
                      <th id="{{'V034-' + ja}}">
                        <span class="field-code">V034 json='abstractPartyStatus#', 'cancelDate' </span> 
                        Unpaid Deferred Costs
                      </th>
                     </tr>
                    </thead>
                    <tbody>
                    <ng-template ngFor let-ap="index" let-abstractParty [ngForOf]="abstract.getAbstractPartiesList(civilCase, 'C')">                                 
                      <tr>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedParty'}}">
                          {{abstract.getAffectedParty(civilCase, abstractParty)}}
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-partiesAffected-' + ap + '-affectedPartyStatus'}}">
                          {{abstract.getPayoffCalculatorCreditorUnpaidDeferredCosts(abstractParty) | currency:'USD':'symbol':'1.2-2'}}                            
                        </td>
                      </tr>
                    </ng-template>  
                    </tbody>
                   </table>
                 </div>
               </div>
             </div>
           </div>
         </div>
        </div>   <!--  Parties Affected by this Judgment and Payoff Amounts -->
    
        <div class="row panel-margin-bottom panel-margin-top" *ngIf="civilCase.getIssueListByAbstractKey(abstract.getKey()).length !== 0">
         <div class="col-md-12 panel panel-default">
          <div id="{{'X004c'}}" class="panel-title summary-label">
            Issues Covered by this Judgment
          </div>
          <div class="panel-body panel-body-bottom">
            <div class="table-responsive">
              <table class="table table-condensed table-striped">
                <thead>
                  <tr>
                    <th id="{{'V004b-' + ja}}">
                      <span class="field-code">V004b json='pleadings.clockDate' </span> Issue Clocked In
                    </th>
                    <th id="{{'V051b-' + ja}}">
                      <span class="field-code">V051b json='pleadings.pleadingType.description' </span> Filing
                    </th>
                    <th id="{{'V005b-' + ja}}">
                      <span class="field-code">V005b json='issues.issueType.description' </span> Issue
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let issueItem of civilCase.getIssueDisplayListByAbstract(abstract); let is = index">
                    <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-issuesCovered-' + is + '-issueClockedIn'}}">
                      {{issueItem.issueClockedInDate | date:'MM/dd/yyyy'}}
                    </td>
                    <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-issuesCovered-' + is + '-pleadingKey'}}">
                      {{issueItem.issuePleading}}
                    </td>
                    <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-issuesCovered-' + is + '-issueType'}}">
                      {{issueItem.issueType}}
                    </td>
                  </tr>
                </tbody>
              </table>
             </div>
           </div>
         </div>
        </div>   <!-- Issues Covered by this Judgment -->
        
  
        <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getAbstractPartyAssignmentList().length !== 0">
         <div class="col-md-12 panel panel-default">
          <div id="{{'X090-' + ja}}" class="panel-title summary-label">
            Assignments of the Right to Enforce this Judgment
          </div>
          <div class="panel-body panel-body-bottom">
            <div class="table-responsive">
            <table class="table table-condensed table-striped">
              <thead>
                <tr>
                  <th id="{{'V068h-' + ja}}">
                    <span class="field-code">V068h V052g V053g json='parties.name','parties.partyRole.description','parties.partyNumber' </span>Creditor
                  </th>
                  <th id="{{'V216-' + ja}}">
                    <span class="field-code">V216 json='abstracts.assignmentDate' </span> From
                  </th>
                  <th id="{{'V217-' + ja}}">
                    <span class="field-code">V217 json='cancelledDate' </span> To
                  </th>
                  <th id="{{'V218-' + ja}}">
                    <span class="field-code">V218 json='assigneeName' </span> Assignee
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let assignment of abstract.getAbstractPartyAssignmentList(); let ass = index">
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-assignmentRights-' + ass + '-creditor'}}">
                    {{abstract.getCreditor(civilCase, assignment)}}
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-assignmentRights-' + ass + '-assignmentDate'}}">
                    {{abstract.getAssignmentDate(assignment) | date:'MM/dd/yyyy'}}
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-assignmentRights-' + ass + '-cancelledDate'}}">
                    {{abstract.getCancelledDate(assignment) | date:'MM/dd/yyyy'}}
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-assignmentRights-' + ass + '-assignmentName'}}">
                    {{abstract.getAssignmentName(assignment)}}
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
         </div>
        </div>  <!-- Assignments of the Right to Enforce this Judgment -->
        
        <ng-container *ngFor="let costDetail of abstract.getCostFeesDetailList(); let cd = index">
        <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getDetailNumber(costDetail) !== null" >
         <div class="col-sm-12 panel panel-default">
          <div class="panel-title summary-label">
            <span class="field-code">V286c json='detailNumber' </span>             
            <span id="{{'V286c-' + ja + '-' + cd}}"> Cost Detail</span>                        
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-detailNumber'}}"> 
              {{abstract.getDetailNumber(costDetail)}}:</span>
            <span class="field-code">V509 json='abstractPartyLiableList#, attorneyFeeAmount#','postJudgmentCostAmount#','preJudgmentCostAmount#' </span>
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-costDetail'}}">
              {{abstract.getCostDetail(costDetail) | currency:'USD':'symbol':'1.2-2'}}</span> 
            - <span class="field-code">V241 json='preJudgmentType.description'</span>
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-preJudgmentType'}}">
              {{abstract.getPreJudgmentType(costDetail)}}</span>
           <span class="field-code" >V287b json='abstractDetailStatus.description'</span>
           <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-abstractDetailStatus'}}">
            {{abstract.getAbstractDetailStatus(costDetail)}}
            </span>
          </div>
          <div class="panel-body panel-body-bottom">
            <div class="row panel-margin-bottom panel-margin-top">
             <div class="col-sm-12 panel panel-default">
              <app-creditor-section [civilCase]="civilCase" 
               [abstract]="abstract" 
               [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, costDetail, 'C')"
               [jaIndex]="ja" [detailName]="abstract.getDetailStringName('cost')" 
               [detailType]="abstract.getDetailStringName('Creditors')"
               [vCodeLabelDigit]="abstract.getDetailStringName('H')"
               [showDebtorSection]=false>
              </app-creditor-section>
            </div>
          </div>
          <div class="row panel-margin-bottom panel-margin-top">
            <div class="col-sm-12 panel panel-default">
              <app-creditor-section 
                [civilCase]="civilCase" 
                [abstract]="abstract" 
                [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, costDetail, 'D')"
                [jaIndex]="ja" [detailName]="abstract.getDetailStringName('cost')" 
                [detailType]="abstract.getDetailStringName('Debtors')"
                [vCodeLabelDigit]="abstract.getDetailStringName('I')"
                [debtorDetailName]="abstract.getDetailStringName('Cost Detail ') + abstract.getDetailNumber(costDetail)"
                [showDebtorSection]=true
                >
              </app-creditor-section>
            </div>
          </div>
          <div class="row panel-margin-bottom panel-margin-top">
            <div class="col-sm-12 panel panel-default">
              <div id="{{'X249-' + ja + '-' + cd}}" class="panel-title">
                Itemized Costs
              </div>
              <div class="panel-body panel-body-bottom">
                <div class="table-responsive">
                  <table class="table table-condensed table-striped">
                    <thead>
                      <tr>
                        <th id="{{'V249-' + ja + '-' + cd}}">
                          <span class="field-code">V249 json='courtCosts.date' </span>Date
                        </th>
                        <th id="{{'V250-' + ja + '-' + cd}}">
                          <span class="field-code">V250b json='costsType.description' </span>Type of Cost
                        </th>
                        <th id="{{'V251-' + ja + '-' + cd}}">
                          <span class="field-code">V251c json='courtCosts.amount' </span>Amount
                        </th>
                        <th id="{{'V090-' + ja + '-' + cd}}">
                          <span class="field-code">V068k V052j V053j json='courtCosts.party.partyRole.code#','courtCosts.party.partyNumber#', 'parties.name','parties.description', 'parties.partyNumber' </span>Incurring Party
                        </th>
                        <th id="{{'V256-' + ja + '-' + cd}}">
                          <span class="field-code">V256 json='courtCosts.indigentCountyNumber#' </span>Indigent
                        </th>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemizedCosts of abstract.getItemizedCostList(civilCase, abstract.getAbstractJudgmentNumber(), abstract.getAbstractCode(), abstract.getDetailNumber(costDetail)); let ic = index">
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-itemizedCost' + ic + '-itemizedCostDate'}}">
                          {{itemizedCosts.getItemizedCostsDate() | date:'MM/dd/yyyy'}}
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-itemizedCost' + ic + '-itemizedCostTypeOfCosts'}}">
                          {{itemizedCosts.getItemizedCostsTypeOfCost()}}
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-itemizedCost' + ic + '-itemizedCostAmount'}}">
                          {{itemizedCosts.getItemizedCostsAmount() | currency:'USD':'symbol':'1.2-2'}}
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-itemizedCost' + ic + '-itemizedCostPartyInfo'}}">
                          {{itemizedCosts.getItemizedCostsPartyInfo(civilCase)}}
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-itemizedCost' + ic + '-itemizedCostIndigentCounty'}}">
                          {{itemizedCosts.getItemizedCostsIndigentCounty()}}
                        </td>
                      </tr>
  
                      <tr *ngIf="abstract.getItemizedOtherCostsAmount(costDetail) !== 0">
                        <td>
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-postJudgmentCostAmount'}}">
                          OTHER
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-postItemizedOtherCostAmount'}}">
                          <span class="field-code">Vd json='postJudgmentCostAmount#','postJudgmentCostAmount' </span>
                          {{abstract.getItemizedOtherCostsAmount(costDetail) | currency:'USD':'symbol':'1.2-2'}}
                        </td>
                        <td>
                        </td>
                        <td>                            
                        </td>
                      </tr>
  
                      <tr *ngIf="abstract.getAttorneyFees(costDetail) !== 0">
                        <td>
                        </td>
                        <td id="{{'X245d-' + ja + '-' + cd}}">
                            ATTORNEY FEES
                        </td>
                        <td id="{{'V245d-' + ja + '-' + cd}}" *ngIf="abstract.getAttorneyFees(costDetail) !== 0">
                          <span class="field-code" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-attorneyFeeAmount'}}">V245d json='attorneyFeeAmount#','attorneyFeeAmount' </span>                            
                            {{abstract.getAttorneyFees(costDetail) | currency:'USD':'symbol':'1.2-2'}}
                        </td>  
                        <td>
                        </td>
                        <td>                            
                        </td>
                      </tr>
                      <tr *ngIf="abstract.getAttorneyFees(costDetail) === 0 && abstract.getAttorneyFeesTBD(costDetail) !== ''">
                        <td>
                        </td>
                        <td id="{{'X245d-' + ja + '-' + cd}}">
                            ATTORNEY FEES
                        </td>
                        <td id="{{'V245d-' + ja + '-' + cd}}">
                          <span class="field-code" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-attorneyFeeAmount'}}">V245d json='attorneyFeeAmount#','attorneyFeeAmount' </span>                            
                            {{abstract.getAttorneyFeesTBD(costDetail)}}
                        </td>
  
                        <td>
                        </td>
                        <td>                            
                        </td>
                      </tr>
  
                      <tr>
                        <td>
                        </td>
                        <td id="{{'X509-' + ja + '-' + cd}}" style="border-top: thick double;">
                          <strong>Total</strong>
                        </td>
                        <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-costDetail-' + cd + '-total'}}" style="border-top: thick double;">
                          <span class="field-code">V509 json='attorneyFeeAmount','postJudgmentCostAmount','preJudgmentCostAmount' </span>
                            {{abstract.getItemizedCostsAmountTotal(costDetail) | currency:'USD':'symbol':'1.2-2'}} {{abstract.getAttorneyFeesPlusTBD(costDetail)}}
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>    <!-- cost detail -->
        </ng-container>
        
        <ng-container *ngFor="let money of abstract.getMoneyDetailList(); let mn = index">
        <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getDetailNumber(money) !== null">
         <div class="col-sm-12 panel panel-default">
         <!-- this panel is dulicated here, once for attorney fees TBD, and one when its not TBD -->
          <div class="panel-title" *ngIf="abstract.getPlusInterestAttorneyFeeText(money) !== 'Attorney fees only' &&
                                        abstract.getPlusInterestAttorneyFeeText(money) !== 'Attorney fees are to be determined'">
           <span class="field-code">V286d json='detailNumber'</span>
           <span id="{{'V286d-' + ja + '-' + mn}}"> Money Award Detail </span>
           <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyDetailAward'}}">
            {{abstract.getDetailNumber(money)}}: 
           </span>
           <span class="field-code" >V389 json='principalAmount' </span>
           <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-principalAmount'}}">
            {{abstract.getPrincipalAmount(money) | currency:'USD':'symbol':'1.2-2'}}
            {{abstract.getPlusInterestAttorneyFeeText(money)}}
           </span> 
           <span class="field-code" >V287c json='abstractDetailStatus.description' </span>            
           <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyDetailStatus'}}"> 
            {{abstract.getAbstractDetailStatus(money)}} 
           </span>
          </div>
          <div class="panel-title" *ngIf="abstract.getPlusInterestAttorneyFeeText(money) === 'Attorney fees only' ||
                                        abstract.getPlusInterestAttorneyFeeText(money) === 'Attorney fees are to be determined'">
            <span class="field-code">V286d json='detailNumber'</span>
            <span id="{{'V286d-' + ja + '-' + mn}}"> Money Award Detail </span>
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyDetailAward'}}">
              {{abstract.getDetailNumber(money)}}: 
            </span>
            <span class="field-code" >V389 json='principalAmount' </span>
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-principalAmount'}}">
              {{abstract.getPlusInterestAttorneyFeeText(money)}}
            </span> 
            <span class="field-code" >V287c json='abstractDetailStatus.description' </span>            
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyDetailStatus'}}"> 
              {{abstract.getAbstractDetailStatus(money)}} 
            </span>
          </div>
          <div class="panel-body panel-body-bottom">
            <div class="row panel-margin-bottom panel-margin-top">
               <div class="panel panel-default">
                <app-creditor-section 
                  [civilCase]="civilCase" 
                  [abstract]="abstract" 
                  [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, money, 'C')"
                  [jaIndex]="ja"
                  [detailName]="abstract.getDetailStringName('money')"
                  [detailType]="abstract.getDetailStringName('Creditors')"
                  [vCodeLabelDigit]="abstract.getDetailStringName('K')"
                  [showDebtorSection]=false>
                </app-creditor-section>
              </div>
            </div>
            <div class="row panel-margin-bottom panel-margin-top">
              <div class="panel panel-default">
                <app-creditor-section 
                  [civilCase]="civilCase" 
                  [abstract]="abstract" 
                  [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, money, 'D')"
                  [jaIndex]="ja"
                  [detailName]="abstract.getDetailStringName('money')"
                  [detailType]="abstract.getDetailStringName('Debtors')"
                  [vCodeLabelDigit]="abstract.getDetailStringName('L')"
                  [debtorDetailName]="abstract.getDetailStringName('Money Award Detail ') + abstract.getDetailNumber(money)"
                  [showDebtorSection]=true
                  >
                </app-creditor-section>
              </div>
            </div>
            <div class="row panel-margin-bottom panel-margin-top">
             <div class="col-sm-12 panel panel-default">
              <div id="{{'V389-' + ja + '-' + mn}}" class="panel-title">
                Interest Calculation
              </div>
              <div class="panel-body panel-body-bottom">
                <div class="row row-eq-height">
                  <div class="col-sm-6 panel panel-default">
                    <div id="{{'X389-' + ja + '-' + mn}}" class="panel-title">
                      <span class="field-code">V389 json='principalAmount' </span> Principal
                    </div>
                    <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-interestCalculation-principalAmount'}}">
                      {{abstract.getPrincipalAmount(money) | currency:'USD':'symbol':'1.2-2'}}
                    </div>
                  </div>
                  <div class="col-sm-6 panel panel-default" *ngIf="abstract.getMoneyAwardDetailPreJudgmentInterest(money) !== 0">
                    <div id="{{'X388-' + ja + '-' + mn}}" class="panel-title">
                      <span class="field-code">V388 json='preJudgmentInterestAmount' </span> Pre-Judgment Interest
                    </div>
                    <div class="panel-body panel-body-bottom" *ngIf="abstract.getMoneyAwardDetailPreJudgmentInterest(money) !== 0" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-interestCalculation-prejudmentInterest'}}">
                      {{abstract.getMoneyAwardDetailPreJudgmentInterest(money) | currency:'USD':'symbol':'1.2-2'}}
                    </div>
                  </div>
                </div>
                <div class="row"  *ngIf="abstract.getMoneyIntervalList(money).length !== 0">
                  <div class="col-sm-12 panel panel-default">
                    <div class="panel-body panel-body-bottom">
                      <div class="table-responsive">
                        <table class="table table-condensed table-striped">
                          <thead>
                            <tr>
                              <th id="{{'V392-' + ja + '-' + mn}}">
                                <span class="field-code">V392 json='fromDate' </span> From
                              </th>
                              <th id="{{'V393-' + ja + '-' + mn}}">
                                <span class="field-code">V393 json='throughDate#' </span> Through
                              </th>
                              <th id="{{'V390-' + ja + '-' + mn}}">
                                <span class="field-code">V390c json='interestRate','simpleCompoundIndicator.description' </span>Interest
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let interval of abstract.getMoneyIntervalList(money); let in = index">
                              <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyInterval-' + in + '-awardDetailFromDate'}}">
                                {{abstract.getMoneyAwardDetailFromDate(interval) | date:'MM/dd/yyyy'}}
                              </td>
                              <td *ngIf="abstract.getMoneyAwardDetailThroughDate(interval) === ''" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyInterval-' + in + '-awardDetailThroughDate'}}">
                                INDEFINITELY 
                              </td>
                              <td *ngIf="abstract.getMoneyAwardDetailThroughDate(interval) !== ''" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyInterval-' + in + '-awardDetailThroughDate'}}">
                                {{abstract.getMoneyAwardDetailThroughDate(interval) | date:'MM/dd/yyyy'}}
                              </td>
                              <td *ngIf="abstract.getMoneyAwardDetailInterestMoney(interval) !== null" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyInterval-' + in + '-awardDetailInterestMoney'}}">
                                {{abstract.getMoneyAwardDetailInterestMoney(interval)}}% {{abstract.getMoneyAwardDetailInterestMoneyDescription(interval)}} INTEREST
                              </td>
                              <td *ngIf="abstract.getMoneyAwardDetailPerDayMoney(interval) !== ''" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-moneyInterval-' + in + '-awardDetailInterestMoney'}}">
                                {{abstract.getMoneyAwardDetailPerDayMoney(interval) | currency:'USD':'symbol':'1.2-2'}} per day 
                              </td>                                
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="abstract.getAttorneyFeesTbd(money) !== '-' ||
                                        abstract.getAttorneyFeesAwrd(money) !== '-' ||
                                        abstract.getAttorneyFeesPercentAwrd(money) !== ''">
                  <div class="col-sm-12 panel panel-default">
                    <div id="{{'X394-' + ja + '-' + mn}}" class="panel-title">
                      Attorney Fees
                    </div>
                    <div class="panel-body panel-body-bottom">
                      <div *ngIf="abstract.getAttorneyFeesTbd(money) !== '-'" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-attorneyFees'}}">
                        <span class="field-code">V394 json='abstractAttorneyFeeType.code#'</span>{{abstract.getAttorneyFeesTbd(money)}}.
                      </div>
                      <div *ngIf="abstract.getAttorneyFeesAwrd(money) !== '-'" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-attorneyFeesAmount'}}">
                        <span class="field-code">V394 json='attorneyFeeAmount#'</span>{{abstract.getAttorneyFeesAwrd(money)}} {{abstract.getAttorneyFeesAwrdMoney(money) | currency:'USD':'symbol':'1.2-2'}}.
                      </div>
                      <div *ngIf="abstract.getAttorneyFeesPercentAwrd(money) !== ''" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-moneyDetail-' + mn + '-attorneyFeesCode'}}">
                        <span class="field-code">V394 json='abstractAttorneyFeeType.code#','attorneyFeePercent#','abstractAttorneyFeeIncludeCode.description', 'attorneyFeePercent'</span>{{abstract.getAttorneyFeesPercentAwrd(money)}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  <!-- interest calculation -->
        </div>   <!-- money award panel body -->
      </div>
    </div>  <!-- money award list -->
    </ng-container>
    
    <!--- property award -->
    <ng-container *ngFor="let property of abstract.getPropertyAwardDetailList(); let pr = index">
    <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getDetailNumber(property) !== null">
      <div class="col-sm-12 panel panel-default">
        <div class="panel-title summary-label">
          <span class="field-code" >V286e json='detailNumber' </span>
          <span id="{{'V286e-' + ja + '-' + pr}}"> Property Award Detail </span>
          <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-propertyDetail-' + pr + '-detailNumber'}}"> 
              {{abstract.getDetailNumber(property)}}</span><span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-propertyDetail-' + pr + '-registerDeeds'}}">{{abstract.getPropertyCountyRegisterOfDeeds(property)}}
          </span>
          <span class="field-code" >V287d json='abstractDetailStatus.description' </span>
          <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-propertyDetail-' + pr + '-detailStatus'}}">    
            {{abstract.getAbstractDetailStatus(property)}}
          </span>
        </div>
        <div class="panel-body panel-body-bottom">
          <div class="row panel-margin-bottom panel-margin-top" id="C-property-section">
            <div class="col-sm-12 panel panel-default">
              <app-creditor-section 
                  [civilCase]="civilCase" 
                  [abstract]="abstract" 
                  [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, property, 'C')"
                  [jaIndex]="ja"
                  [detailName]="abstract.getDetailStringName('property')"
                  [detailType]="abstract.getDetailStringName('Creditors')"
                  [vCodeLabelDigit]="abstract.getDetailStringName('M')"
                  [showDebtorSection]=false>
                </app-creditor-section>
            </div>
          </div>
          <div class="row panel-margin-bottom panel-margin-top" id="D-property-section">
            <div class="col-sm-12 panel panel-default">
              <app-creditor-section 
                  [civilCase]="civilCase" 
                  [abstract]="abstract" 
                  [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, property, 'D')"
                  [jaIndex]="ja"
                  [detailName]="abstract.getDetailStringName('property')"
                  [detailType]="abstract.getDetailStringName('Debtors')"
                  [vCodeLabelDigit]="abstract.getDetailStringName('N')"
                  [showDebtorSection]=false>
                </app-creditor-section>
            </div>
          </div>
          
          <div class="row panel-margin-bottom panel-margin-top"  *ngIf="abstract.getDetailDescription(property).trim()">
            <div class="col-sm-12 panel panel-default">                      
              <div id="{{'X423a-' + ja + '-' + pr}}" class="panel-title summary-label">
                  <span class="field-code">V423a json='registerDeedsCountyNumber#'</span>Description of Property
              </div>
              <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
                <div class="row row-eq-height">
                  <div class="col-sm-2 panel panel-default" *ngIf="abstract.getPropertyRegisterDeedsCountyNumber(property) !== '-'">
                    <div class="panel-title">
                        <span class="field-code">V421 json='registerDeedsCountyNumber' </span> 
                          Property County
                    </div>
                    <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-propertyDetail-' + pr + '-registerDeedsCountyNumber'}}">
                        {{abstract.getPropertyRegisterDeedsCounty(property)}}
                    </div>
                  </div>
                  <div class="col-sm-2 panel panel-default"  *ngIf="abstract.getPropertyRegisterDeedsBook(property) !== '-'">
                      <div id="{{'V418-' + ja + '-' + pr}}" class="panel-title">
                        <span class="field-code">V418 V419 json='registerDeedsBook','registerDeedsPage' </span>
                          Register of Deeds Book and Page
                      </div>
                      <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-propertyDetail-' + pr + '-registerDeedsBookPage'}}">
                        {{abstract.getPropertyRegisterDeedsBook(property)}} / {{abstract.getPropertyRegisterDeedsPage(property)}}
                      </div>
                  </div>
                  <div class="col-sm-8 panel panel-default" *ngIf="abstract.getDetailDescription(property) !== '-'">
                    <div class="panel-body panel-body-bottom">
                      <span class="field-code" >json='textDescriptionList' </span>                       
                      <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-propertyDetail-' + pr + '-detailDescription'}}"> 
                        {{abstract.getDetailDescription(property)}}</span>
                    </div>
                  </div>
                </div>  
              </div>     
            </div>
          </div>
        </div>
      </div>
    </div>   <!-- property award detail -->
    </ng-container>
  
    <ng-container *ngFor="let special of abstract.getSpecialAwardDetailList(); let sp = index">
    <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getDetailNumber(special) !== null">
      <div class="col-sm-12 panel panel-default">
        <div class="panel-title summary-label">
          <span class="field-code" >V286f json='detailNumber' </span>
          <span id="{{'V286f-' + ja + '-' + sp}}">
              Special Award Detail 
          </span>
          <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-specialDetail-' + sp + '-detailNumber'}}">
            {{abstract.getDetailNumber(special)}}
          </span>
          <span class="field-code" >V287e json='abstractDetailStatus.description' </span>            
          <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-specialDetail-' + sp + '-detailStatus'}}">
            {{abstract.getAbstractDetailStatus(special)}}
          </span>
        </div>
        <div class="panel-body panel-body-bottom" style="padding-left: 2em;">
          <div class="row panel-margin-bottom panel-margin-top">
            <div class="col-sm-12 panel panel-default">
              <app-creditor-section 
                  [civilCase]="civilCase" 
                  [abstract]="abstract" 
                  [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, special, 'C')"
                  [jaIndex]="ja"
                  [detailName]="abstract.getDetailStringName('special')"
                  [detailType]="abstract.getDetailStringName('Creditors')"
                  [vCodeLabelDigit]="abstract.getDetailStringName('o')"
                  [showDebtorSection]=false>
                </app-creditor-section>
            </div>
          </div>
          <div class="row panel-margin-bottom panel-margin-top">            
            <div class="col-sm-12 panel panel-default">
              <app-creditor-section 
                  [civilCase]="civilCase" 
                  [abstract]="abstract" 
                  [abstractDetailList]="abstract.getAbstractPartyLiableList(civilCase, special, 'D')"
                  [jaIndex]="ja"
                  [detailName]="abstract.getDetailStringName('special')"
                  [detailType]="abstract.getDetailStringName('Debtors')"
                  [vCodeLabelDigit]="abstract.getDetailStringName('P')"
                  [showDebtorSection]=false>
                </app-creditor-section>
            </div>
          </div>
          <div class="row panel-margin-bottom panel-margin-top">
            <div class="col-sm-12 panel panel-default">
              <div class="panel-title">
                <span id="V423" class="field-code">V423 json='textDescriptionList' </span> Description
              </div>
              <div class="panel-body panel-body-bottom" id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-specialDetail-' + sp + '-description'}}">
                {{abstract.getDetailDescription(special)}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>  <!-- Special Award Detail -->
    </ng-container>
  
    <!--- payments on judgement -->
    <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getAbstractPaymentList().length > 0">
      <div class="col-sm-12 panel panel-default">
        <div class="panel-title summary-label">
          <span class="field-code">V029 json='abstractNumber' </span> 
          <span id="{{'V029-' + ja}}">Payments on Judgment</span>
          <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-number'}}">{{abstract.getAbstractJudgmentNumber()}}</span>
        </div>
        <div class="panel-body panel-body-bottom">
          <div class="table-responsive">
            <table class="table table-condensed table-striped ">
              <thead>
                <tr>
                  <th id="{{'V191-' + ja}}">
                    <span class="field-code">V191 json='paymentNumber' </span> Payment Number
                  </th>
                  <th id="{{'V090-' + ja}}">
                    <span class="field-code">V068r V052q/V053q json='partyRef' </span> Debtor
                  </th>
                  <th id="{{'V090-' + ja}}">
                    <span class="field-code">V207/V208 json='noticeIndicator.description, noticeDate'</span>Activity
                  </th>                    
                  <th id="{{'V201-' + ja}}">
                    <span class="field-code">V201 json='paymentDate' </span> Transaction Date
                  </th>
                  <th id="{{'V192-' + ja}}">
                    <span class="field-code">V192 json='abstractPaymentType.description#, abstractPaymentType.description' </span> Transaction Type
                  </th>
                  <th id="{{'V195-' + ja}}">
                    <span class="field-code">V195 json='abstractPaymentType.description#, amount' </span> Amount
                  </th>
                </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let payment of abstract.getAbstractPaymentList(); let py = index;">
                <tr *ngFor="let transaction of getAbstractPaymentTransactionDisplayList(abstract,payment); let tn = index; let last = last; ">
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-'+ tn + '-paymentNumber'}}" 
                      rowspan="1"
                      *ngIf="(tn===0)">
                    <div *ngIf="(!last || (last && abstract.getShowAdjustedPayment(payment) === false))">
                      <span>{{abstract.getPaymentsOnJudgmentPaymentNumber(payment)}}</span>
                    </div>
                    <div *ngIf="last && abstract.getShowAdjustedPayment(payment) === true">
                        <span>&nbsp;</span>
                    </div>
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-'+ tn + '-debtor'}}"
                      rowspan="1"
                      *ngIf="(tn===0)">
                    <div *ngIf="(!last || (last && abstract.getShowAdjustedPayment(payment) === false))">
                      <span>{{abstract.getPaymentsOnJudgmentDebtor(civilCase, payment)}}</span>
                    </div>
                    <div *ngIf="last && abstract.getShowAdjustedPayment(payment) === true">
                      <span>&nbsp;</span>
                    </div>
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-'+ tn +  '-creditor'}}">
                    <div *ngIf="(!last || (last && abstract.getShowAdjustedPayment(payment) === false))">
                      <span *ngIf="abstract.getPaymentsOnNoticeDescriptionToCreditor(civilCase, transaction) !== '-'">
                        Notice of {{abstract.getPaymentsOnNoticeDescriptionToCreditor(civilCase, transaction)}} was generated on {{abstract.getPaymentsOnNoticeDateToCreditor(transaction) | date:'MM/dd/yyyy'}}.
                      </span>
                      <span *ngIf="abstract.getPaymentsOnNoticeDescriptionToCreditor(civilCase, transaction) === '-'">
                        &nbsp;
                      </span>
                    </div>
                    <div *ngIf="last && abstract.getShowAdjustedPayment(payment) === true">
                     <span>&nbsp;</span>
                    </div>
                  </td> 
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-'+ tn +  '-transactionDate'}}">                        
                    <div *ngIf="(!last || (last && abstract.getShowAdjustedPayment(payment) === false))">
                      <span>{{abstract.getPaymentsOnJudgmentTransactionDate(transaction) | date:'MM/dd/yyyy'}}</span>
                    </div>
                    <div *ngIf="last && abstract.getShowAdjustedPayment(payment) === true">
                      <span>&nbsp;</span>
                    </div>   
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-'+ tn +  '-transactionType'}}">
                    <div *ngIf="(!last || (last && abstract.getShowAdjustedPayment(payment) === false)) ">
                      <span>{{abstract.getPaymentsOnJudgmentTransactionType(transaction)}}</span>
                    </div>  
                    <div *ngIf="last && abstract.getShowAdjustedPayment(payment) === true">
                      <span><span class="field-code">V196 json='paymentTransactionList#' </span> ADJUSTED PAYMENT</span>
                    </div> 
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-'+ tn + '-amount'}}">
                    <div *ngIf="(!last || (last && abstract.getShowAdjustedPayment(payment) === false))">
                       <span *ngIf="abstract.getPaymentsOnJudgmentAmount(transaction, false) >= 0">
                          {{abstract.getPaymentsOnJudgmentAmount(transaction, false) | currency:'USD':'symbol':'1.2-2'}}                    
                       </span>
                       <span *ngIf="abstract.getPaymentsOnJudgmentAmount(transaction, false) < 0">
                            -{{abstract.getPaymentsOnJudgmentAmount(transaction, true) | currency:'USD':'symbol':'1.2-2'}}
                       </span>
                    </div>
                    <div *ngIf="last && abstract.getShowAdjustedPayment(payment) === true">
                       <span *ngIf ="abstract.getAdjustedPaymentAmount(payment, false) >= 0">                                
                            {{abstract.getAdjustedPaymentAmount(payment, false) | currency:'USD':'symbol':'1.2-2'}}                    
                       </span> 
                       <span *ngIf ="abstract.getAdjustedPaymentAmount(payment, false) < 0">                                
                              -{{abstract.getAdjustedPaymentAmount(payment, true) | currency:'USD':'symbol':'1.2-2'}}
                       </span>                                                          
                    </div>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>   <!-- Payments on Judgment -->
  
      <div class="row panel-margin-bottom panel-margin-top" *ngIf="abstract.getAbstractDisbursementList().length > 0">
        <div class="col-sm-12 panel panel-default">
          <div class="panel-title summary-label">
            <span class="field-code">V036 json='abstractNumber' </span> 
            <span id="{{'V036-' + ja}}" >Disbursements on Judgment</span>           
            <span id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment-number'}}">{{abstract.getAbstractJudgmentNumber()}}</span>
          </div>
          <div class="panel-body panel-body-bottom">
            <div class="table-responsive">
            <table class="table table-condensed table-striped ">
              <thead>
                <tr>
                  <th id="{{'V191-' + ja}}">
                    <span class="field-code">V191 json='paymentNumber' </span> Payment Number
                  </th>
                  <th id="{{'V277-' + ja}}">
                    <span class="field-code">V277 json='paymentAuthorizationDate' </span> Authorization Date
                  </th>                    
                  <th id="{{'V276-' + ja}}">
                    <span class="field-code">V276 json='paymentAuthorizationNumber' </span> Authorization Number
                  </th>
                  <th id="{{'V068t-' + ja}}">
                    <span class="field-code">V068t+V052s+V053s+V283+V285 json='mailTo,' 'mailToAddress'</span>Payee(s)
                  </th>
                  <th id="{{'V280-' + ja}}">
                    <span class="field-code">V280 json='grossDistributionAmt' </span> Amount
                  </th>                    
                  <th id="{{'V493-' + ja}}">
                    <span class="field-code">V493 json='payoffDispute' </span> Payoff Dispute
                  </th>
                  <th id="{{'V279-' + ja}}">
                    <span class="field-code">V279 json='disbursementStatus' </span> Disbursement Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let disbursement of abstract.getAbstractDisbursementList(civilCase); let disb = index">
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment-' + '-number'}}">
                    {{abstract.getDistributionsOnJudgmentPaymentNumber(disbursement)}}
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgmen-authorizationDate'}}">
                    {{abstract.getDistributionsOnJudgmentAuthorizationDate(disbursement) | date:'MM/dd/yyyy'}}
                  </td>                    
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment' + '-authorizationNumber'}}">
                    {{abstract.getDistributionsOnJudgmentAuthorizationNumber(disbursement)}}
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment' + '-payeeName'}}">
                    <tr *ngFor="let creditor of abstract.getAbstractDisbursementCreditorList(civilCase, disbursement); let creditorIndex = index">
                      {{abstract.getDistributionsOnJudgmentPayeeName(civilCase, disbursement, creditor)}}
                    </tr>  
                    <tr id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment' + '-payeeAddress'}}">
                      <strong>Mail to:</strong>
                    </tr>
                    <tr>
                      {{abstract.getDistributionsOnJudgmentMailToName(disbursement)}}                      
                    </tr>
                    <div *ngIf="abstract.showDisbursementAddress(disbursement) === true">
                      <tr>
                        {{abstract.getDistributionsOnJudgmentMailToAddressLine1(disbursement)}}
                      </tr>
                      <div *ngIf="abstract.getDistributionsOnJudgmentMailToAddressLine2(disbursement) !== '-'">
                        <tr>{{abstract.getDistributionsOnJudgmentMailToAddressLine2(disbursement)}}</tr>
                      </div>
                      <tr>
                        {{abstract.getDistributionsOnJudgmentMailToAddressLine3(disbursement)}}
                      </tr>
                    </div>           
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment' + '-amount'}}">
                    {{abstract.getDistributionsOnJudgmentAmount(disbursement) | currency:'USD':'symbol':'1.2-2'}}
                  </td>                    
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment' + '-payoffDispute'}}">
                    {{abstract.getDistributionsOnJudgmentPayoffDispute(disbursement)}}
                  </td>
                  <td id="{{'civil-caseDetails-judgmentAbstracts-' + ja + '-disbursementsOnJudgment' + '-status'}}">
                    {{abstract.getDistributionsOnJudgmentStatus(disbursement)}}
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>   
        </div>
      </div>  <!-- Disbursements on JudgmentDisbursements on Judgment -->
    </div>   <!-- panel body - post abstract -->
    </div>
    </ng-container> <!-- post abstract ng container -->   
    </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/judgments/judgments.component.html